/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { IconChevronLeft, IconCloudDown, IconEdit } from "@tabler/icons-react";
import { useNavigate, useParams } from "react-router-dom";
import {
  useStaffDetailsData,
  useStaffUpdateMutation,
} from "../../apis/staffApis";
import formatDate from "../../utilities/helper";
import AddStaffModal from "./_components/AddStaffModal";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import NewCommonModal from "../../components/common/NewCommonModal";
import { usePermission } from "../../hooks/usePermissionTabs";
export default function ViewStaffDetails() {
  const { id } = useParams();
  const { data: staffDetails, refetch: fetchStaffDetails } =
    useStaffDetailsData(id ?? "");
  const { mutate, isPending: isRequestPending } = useStaffUpdateMutation();
  const [editDialog, setEditDialog] = useState<boolean>(false);
  const [allIds, setAllIds] = useState<any>();
  const getIds = (data: any) => {
    setAllIds(data);
  };
  const [selectedDocument, setSelectedDocument] = useState<any>({
    photo: false,
    iqamaDoc: false,
  });

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    clearErrors,
    control,
    reset,
    formState: { errors },
  } = useForm<any>();

  useEffect(() => {
    if (id) {
      fetchStaffDetails();
    }
  }, [id]);

  const Section = ({
    title,
    children,
  }: {
    title?: string;
    children: React.ReactNode;
  }) => (
    <div className="p-4 bg-[#F7F6F2] rounded-3xl border border-[#EFEFEF] space-y-2">
      <div className="grid grid-cols-2 gap-x-6 ">{children}</div>
    </div>
  );

  // const TwoCol = ({ label, value }: { label: string; value: string }) => (
  //   <div className="text-sm text-[#1E293B] flex justify-between items-center gap-1 border-b py-3 last:border-0 px-4 ">
  //     <p className="font-medium text-[#212121] capitalize">{label}:</p>
  //     <p> {value}</p>
  //   </div>
  // );
  const TwoCol = ({
    label,
    value,
  }: {
    label: string;
    value: React.ReactNode;
  }) => (
    <div className="text-sm text-[#1E293B] flex justify-between items-center gap-1 border-b py-3 last:border-0 px-4 ">
      <p className=" text-[#212121] capitalize">{label}:</p>
      <p className="font-medium"> {value}</p>
    </div>
  );

  const navigate = useNavigate();

  const handleEditStaffToggle = () => {
    setEditDialog(!editDialog);
    if (!editDialog) {
      reset();
    }
  };

  const { allowed: canUpdateStaff, isLoading } = usePermission(
    "staffs",
    "update",
  );

  const handleStaffUpdate = (data: any) => {
    const mergedWarehouses = [];

    if (data.warehouse) mergedWarehouses.push(data.warehouse);
    if (Array.isArray(data.assignWarehouse)) {
      mergedWarehouses.push(
        ...data.assignWarehouse?.map((warehouse: any) => warehouse?.id),
      );
    } else if (data.assignWarehouse) {
      mergedWarehouses.push(data.assignWarehouse);
    }

    let { photo, iqamaDoc, warehouse, supervisorId, ...payload } = data;

    mutate(
      {
        ...payload,
        ...(selectedDocument?.photo && { photo: data?.photo }),
        ...(selectedDocument?.iqamaDoc && { iqamaDoc: data?.iqamaDoc }),
        ...(watch("photo") && { photoAvailabel: true }),
        ...(watch("iqamaDoc") && { iqamaDocAvailabel: true }),
        ...allIds,
        timeSlotId: data?.timeSlotId ? data?.timeSlotId : "",
        staffRolesId: data?.roles,
        warehouses: mergedWarehouses,
        type: "LM",
        id,
      },
      {
        onSuccess: () => {
          setEditDialog(false);
          fetchStaffDetails();
          toast.success("Staff Update Successfully.");
          navigate("/users?tab=Staff");
        },
        onError: (error: any) => {
          console.error(error);
          const errorMessage =
            error?.response?.data?.error?.message ||
            error?.response?.data?.message ||
            error?.message ||
            (typeof error === "string" ? error : null) ||
            "Failed to Update Staff";

          toast.error(errorMessage);
        },
      },
    );
  };

  return (
    <>
      <div className="p-4 pt-0 space-y-4">
        {/* Header */}
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            <button
              onClick={() => navigate(-1)}
              className="p-1.5 border border-[#D2D2D2] rounded-full hover:bg-[#F7F6F2] transition"
            >
              <IconChevronLeft strokeWidth={1.5} size={22} />
            </button>
            <div className="flex items-center gap-2">
              <img
                src={staffDetails?.photo || "/img/dummy-blank-profile.png"}
                className="size-10 rounded-full  outline-[0.5px] object-cover "
                alt=""
              />
              <h1 className="text-2xl text-[#212121] tracking-[-0.5px]  ">
                {staffDetails?.name}
              </h1>
            </div>
          </div>
        </div>

        {/* Sections */}
        <div className="space-y-4">
          {/* Shipment Info */}
          <div className="grid grid-cols-1 gap-6">
            <Section title={""}>
              <div className="flex justify-between items-center col-span-2 pb-3">
                <h3 className="text-[#212121] font-medium text-lg ">
                  Staff Details{" "}
                </h3>
                {canUpdateStaff && (
                  <button
                    onClick={() => {
                      setEditDialog(true);
                    }}
                    className="flex items-center gap-1  p-2.5  text-sm rounded-full border border-[#FFFFFF] bg-[#F7F6F2]"
                  >
                    <IconEdit stroke={1.5} size={24} />
                  </button>
                )}
              </div>
              <div className="bg-[#FCFDF8] border rounded-2xl overflow-hidden">
                <h3 className="text-[#212121] font-medium text-base capitalize border-b border-gray-300 border-dashed py-2 w-full bg-[#F7F6F2] rounded-t-xl px-4">
                  Personal Details{" "}
                </h3>
                {/* <TwoCol label="Id" value="654654565" /> */}
                <TwoCol label="Name" value={staffDetails?.name} />
                <TwoCol label="Mobile Number" value={staffDetails?.phone} />
                <TwoCol label="Email" value={staffDetails?.email} />
                <TwoCol
                  label="Warehouse"
                  value={staffDetails?.warehouseList?.[0]?.name}
                />
                <TwoCol label="Country" value={staffDetails?.country} />
                <TwoCol label="City" value={staffDetails?.city} />
                <TwoCol label="District" value={staffDetails?.district} />
                <TwoCol
                  label="Assigned Warehouse"
                  value={staffDetails?.warehouseList
                    ?.slice(1)
                    ?.map((w: any) => w.name)
                    ?.join(", ")}
                />
                <TwoCol
                  label="Assigned Outlet"
                  value={staffDetails?.outletList?.[0]?.name || "—"}
                />

                <TwoCol label="Role" value={staffDetails?.roleName} />
                <TwoCol
                  label="Start Date"
                  value={formatDate(staffDetails?.startDate)}
                />
                <TwoCol label="Time Slot" value={staffDetails?.timeslotname} />
                <TwoCol label="Iqama Number" value={staffDetails?.iqamaNo} />
                <TwoCol
                  label="Iqama Number"
                  value={
                    <div className="flex items-center gap-1">
                      <p>{staffDetails?.iqamaNo || ""} </p>
                      {staffDetails?.iqamaDoc && (
                        <a
                          onClick={() => {
                            const url = staffDetails?.iqamaDoc;
                            const link = document.createElement("a");
                            link.href = url;
                            link.target = "_blank";
                            link.download = "";
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                          }}
                          className="inline-flex items-center justify-cente hover:bg-[#FBD037]/20 p-0.5 px-1 rounded cursor-pointer"
                        >
                          <IconCloudDown strokeWidth={1.5} size={22} />
                        </a>
                      )}
                    </div>
                  }
                />
                <TwoCol label="Address" value={staffDetails?.address} />
                <TwoCol
                  label="Short Address"
                  value={
                    staffDetails?.shortAddress &&
                    staffDetails?.shortAddress !== "null"
                      ? staffDetails?.shortAddress
                      : ""
                  }
                />
                <TwoCol
                  label="Supervisor"
                  value={staffDetails?.supervisorName}
                />
                {staffDetails?.darkStoreName && (
                  <TwoCol
                    label="Dark Store"
                    value={staffDetails?.darkStoreName}
                  />
                )}
              </div>
              <div className="bg-[#FCFDF8] border rounded-2xl overflow-hidden">
                <h3 className="text-[#212121] font-medium text-base capitalize border-b border-gray-300 border-dashed py-2 w-full bg-[#F7F6F2] rounded-t-xl px-4">
                  Roles permission{" "}
                </h3>

                {staffDetails?.permissions &&
                  staffDetails?.permissions?.length !== 0 &&
                  staffDetails?.permissions?.map((permission: any) => (
                    <TwoCol
                      label={permission?.dashboard}
                      value={permission?.operations?.join(", ")}
                    />
                  ))}
              </div>
            </Section>
          </div>
        </div>
      </div>
      <NewCommonModal
        title={"Edit Staff"}
        open={editDialog}
        closeButtonText={"Cancel"}
        onClose={handleEditStaffToggle}
        actionButtonText="Update"
        actionButtonOnClick={handleSubmit(handleStaffUpdate)}
        actionButtonProps={{ disabled: isRequestPending }}
        isPending={isRequestPending}
      >
        <AddStaffModal
          register={register}
          errors={errors}
          setValue={setValue}
          watch={watch}
          clearErrors={clearErrors}
          control={control}
          getIds={getIds}
          setSelectedDocument={setSelectedDocument}
          staffDetails={staffDetails}
        />
      </NewCommonModal>
    </>
  );
}
